var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70717 5.76572C8.8573 5.88582 8.8573 6.11415 8.70717 6.23425L4.48741 9.61006C4.29098 9.7672 4 9.62735 4 9.3758L4 2.62417C4 2.37262 4.29098 2.23277 4.48741 2.38991L8.70717 5.76572Z",
    fill: "#072983"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLeft);
export default __webpack_public_path__ + "static/media/blue-left.7b20625fbe520129e3b5887de225927b.svg";
export { ForwardRef as ReactComponent };